import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import banner2 from "./assets/bannerWeb2.png";
import banner3 from "./assets/bannerWeb3.png";
import banner5 from "./assets/bannerWeb5.png";
import banner6 from "./assets/bannerWeb6.png";
import banner7 from "./assets/bannerWeb7.png";

function FeaturedGames() {
    // Array con las imágenes destacadas
    const featuredGames = [
        { src: banner2, alt: "banner 2" },
        { src: banner3, alt: "banner 3" },
        { src: banner7, alt: "banner 7" },
        { src: banner5, alt: "banner 5" },
        { src: banner6, alt: "banner 6" },
        // 
    ];

    return (
        <Carousel 
            showThumbs={false} 
            showArrows={true} 
            showStatus={false}  
            autoPlay 
            infiniteLoop 
            style={{ maxHeight: "500px" }}
        >
            {featuredGames.map((game, index) => (
                <div key={index} style={{  display: "flex",position: "relative", marginTop:"15vh", justifyContent: "center", alignItems: "center" }}>
                    <img src={game.src} alt={game.alt} style={{ height: "100%", objectFit: "contain" }} />
                </div>
            ))}
        </Carousel>
        
        
    );
}

export default FeaturedGames;